import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";

function Intakequotaallocation() {
    const formattedTitle = useLocation().pathname
        .split('/').pop()
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    const navigate = useNavigate();
    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <section className="content-header">
                                        <a href="https://www.youtube.com/watch?v=9ZTu_aOSmfg" data-fancybox="youtube" className="youtube-link btn btn-danger"><i className="fa fa-youtube-play" aria-hidden="true" /> &nbsp;Youtube Training Video</a>
                                        <h1><i className="fa fa-university" />&nbsp;Intake Quota Allocation
                                        </h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a onClick={() => navigate("/admin-dashboard")} style={{ cursor: "pointer" }}>
                                                    <i className="fa fa-tachometer" style={{ marginRight: "5px" }}></i> Home
                                                </a>
                                            </li>
                                            <li className="active">{formattedTitle}</li>
                                        </ol>
                                    </section>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-4 stretch-card">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="mb-0 p-2" style={{ textTransform: 'uppercase' }}>Chinchuria Upendranath High
                                                School
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6" style={{ borderRight: '1px solid #cecece' }}>
                                                    <div>
                                                        <h4>School Details</h4>
                                                        <hr />
                                                        <ul className="custom">
                                                            <li><i className="fa fa-th-large" aria-hidden="true" />
                                                                <p className="h5">Area - Rural</p>
                                                            </li>
                                                            <li><i className="fa fa-address-card-o" />
                                                                <p className="h5"> Address -
                                                                    Chinchuria,Paschim Bardhaman,West Bengal,713378</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="mt-4">
                                                        <h4>Principal/Headmaster Details</h4>
                                                        <hr />
                                                        <ul className="custom">
                                                            <li><i className="fa fa-user text-green" />
                                                                <p className="h5">Principal's Name - Priyobrata Bannerjee</p>
                                                            </li>
                                                            <li><i className="fa fa-phone text-danger" aria-hidden="true" />
                                                                <p className="h5">Principal's Phone
                                                                    Number - 1111111111</p>
                                                            </li>
                                                            <li><i className="fa fa-phone text-warning" aria-hidden="true" />
                                                                <p className="h5">Assistant's Phone
                                                                    Number - 1111111111</p>
                                                            </li>
                                                            <li><i className="fa fa-envelope text-primary" />
                                                                <p className="h5">School's Email ID -
                                                                    school@gmail.com</p>
                                                            </li>
                                                        </ul>
                                                        {/* <h5><i class="fa fa-user text-green"></i> &nbsp;Principal's Name - Priyobrata Bannerjee</h5>
                                                      <h5><i class="fa fa-phone text-danger" aria-hidden="true"></i> &nbsp;Principal's Phone Number - 1111111111
                                                      </h5>
                                                      <h5><i class="fa fa-phone text-warning" aria-hidden="true"></i> &nbsp;Assistant's Phone Number - 1111111111
                                                      </h5>
                                                      <h5><i class="fa fa-envelope text-primary"></i> &nbsp;School's Email ID - school@gmail.com</h5> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-condensed table-striped">
                                                            <thead>
                                                                <tr className="table-primary">
                                                                    <th>Sl. No.</th>
                                                                    <th>Class</th>
                                                                    <th>Stream</th>
                                                                    <th style={{ width: 150 }}>Assigned Quota</th>
                                                                    <th>Increase Quota by</th>
                                                                    <th>Total Count</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>1</td>
                                                                    <td>Class IX</td>
                                                                    <td>All</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>2</td>
                                                                    <td>Class X</td>
                                                                    <td>All</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>3</td>
                                                                    <td>Class XI</td>
                                                                    <td>Arts</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>4</td>
                                                                    <td>Class XI</td>
                                                                    <td>Commerce</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>5</td>
                                                                    <td>Class XI</td>
                                                                    <td>Science</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>6</td>
                                                                    <td>Class XII</td>
                                                                    <td>Arts</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>7</td>
                                                                    <td>Class XII</td>
                                                                    <td>Commerce</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                                <tr>
                                                                    <td>8</td>
                                                                    <td>Class XII</td>
                                                                    <td>Science</td>
                                                                    <td>50</td>
                                                                    <td><input type="text" className="form-control form-control-xs number text-right" />
                                                                    </td>
                                                                    <td />
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <a type="button" className="btn btn-primary btn-icon-text" style={{ float: 'right' }} href="intake-quota.html">
                                                <i className="ti-save btn-icon-prepend" /> Save </a>
                                            {/* <button class="btn btn-primary me-2" id="previewButton"
                                          style="float: right;">Preview</button>
                                      <button class="btn btn-secondary  me-2" id="edit"
                                          style="float: right;display: none;">Edit</button> */}
                                            <a className="btn btn-secondary  me-2" id="cancelButton" style={{ float: 'right' }}><i className="fa fa-recycle" /> Reset</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Intakequotaallocation